import { render } from "./SaveModalProcedureSearch.vue?vue&type=template&id=b7ed31a8&scoped=true"
import script from "./SaveModalProcedureSearch.vue?vue&type=script&lang=js"
export * from "./SaveModalProcedureSearch.vue?vue&type=script&lang=js"

import "./SaveModalProcedureSearch.vue?vue&type=style&index=0&id=b7ed31a8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7ed31a8"]])

export default __exports__